// Central static content for HEYHOMECAN site
export const COMPANY = {
    name: "HEYHOMECAN",
    legalName: "HEYHOME RESOURCES",
    tagline: "Design your home. Plan it, do it.",
    ssm: "SSM 202503043537 (C90398677-P)",
    address:
        "6-20-12 Vista Danau Kota, Jalan Saujana 1, Taman Danau Kota, 53300 Setapak, Kuala Lumpur",
    email: "heyhomeresources@gmail.com",
    phone: "+60 13-900 7406",
    phoneRaw: "60139007406",
    instagram: "https://www.instagram.com/heyhomecan",
    tiktok: "https://www.tiktok.com/@heyhomecan",
    whatsapp: "https://wa.me/60139007406",
    serviceArea: "Kuala Lumpur & Selangor, Malaysia",
};

export const NAV = [
    { to: "/", label: "Home", testId: "nav-home" },
    { to: "/services", label: "Services", testId: "nav-services" },
    { to: "/portfolio", label: "Portfolio", testId: "nav-portfolio" },
    { to: "/about", label: "About", testId: "nav-about" },
    { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export const SERVICES = [
    {
        slug: "interior-design",
        title: "Interior Design",
        summary:
            "Custom-tailored interiors composed around how you actually live — from concept boards to material palettes.",
        detail:
            "We craft spatial concepts, mood palettes, and detailed layouts that translate the character of each family into a home. Every project begins with careful listening and site studies before a single line is drawn.",
        deliverables: [
            "Concept & moodboard",
            "Space planning & layouts",
            "Material & finish palette",
            "3D visualisations",
        ],
        image:
            "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        slug: "renovation",
        title: "Renovation",
        summary:
            "Full-home renovations delivered with quiet, disciplined project management from demolition to hand-over.",
        detail:
            "Structural adjustments, wet-work, plaster, paint, and finishing — coordinated by a single point of contact so nothing slips between trades.",
        deliverables: [
            "Site assessment",
            "Schedule & phasing plan",
            "Trade coordination",
            "Weekly progress reports",
        ],
        image:
            "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1400&q=80",
    },
    {
        slug: "construction",
        title: "Construction",
        summary:
            "Ground-up build works, extensions, and structural upgrades — engineered to last, finished to be admired.",
        detail:
            "For clients extending or rebuilding, we work with certified engineers and licensed contractors to deliver work that meets Malaysian building standards while carrying our finish quality.",
        deliverables: [
            "Structural drawings",
            "Licensed contractor team",
            "Compliance & permits",
            "Quality inspections",
        ],
        image:
            "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80",
    },
    {
        slug: "kitchen-cabinetry",
        title: "Kitchen & Cabinetry",
        summary:
            "Bespoke kitchens and full-home cabinetry built in-house — engineered joinery, stone surfaces, quiet hardware.",
        detail:
            "From modular kitchens to concealed wardrobes and TV consoles, we design and fabricate cabinetry that lasts a decade of daily use.",
        deliverables: [
            "Bespoke cabinetry drawings",
            "Stone & laminate selection",
            "Soft-close hardware",
            "On-site fitting team",
        ],
        image:
            "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldHJ5fGVufDB8fHx8MTc4MzQzNjg0OHww&ixlib=rb-4.1.0&q=85",
    },
    {
        slug: "ceilings-flooring",
        title: "Ceilings & Flooring",
        summary:
            "Cove ceilings, feature drops, timber and stone flooring — the horizontal surfaces that quietly define a room.",
        detail:
            "Plaster ceilings with recessed lighting, decorative cornices, engineered timber floors and porcelain — installed by trades that specialise, not generalise.",
        deliverables: [
            "Ceiling & cove design",
            "Feature lighting integration",
            "Flooring specification",
            "Warrantied installation",
        ],
        image:
            "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=1400&q=80",
    },
    {
        slug: "refurbishing-decor",
        title: "Refurbishing & Decor",
        summary:
            "Furniture, styling, and decorative finishing — the last 10% of the work that makes a house feel like a home.",
        detail:
            "Curated furniture sourcing, drapery, art placement, and lighting composition. Delivered as a turnkey styling package or as add-ons to a renovation.",
        deliverables: [
            "Furniture curation",
            "Drapery & soft goods",
            "Lighting layers",
            "Move-in day styling",
        ],
        image:
            "https://images.pexels.com/photos/8082243/pexels-photo-8082243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
];

export const PROCESS = [
    {
        step: "01",
        title: "Consult",
        text: "A no-obligation conversation on-site or over WhatsApp. We understand the space, brief, and budget.",
    },
    {
        step: "02",
        title: "Design",
        text: "Concept board, layouts, and 3D visualisations. We refine until you can see yourself living inside the images.",
    },
    {
        step: "03",
        title: "Plan",
        text: "Detailed BQ, schedule, and material list. Transparent pricing and a single point of accountability.",
    },
    {
        step: "04",
        title: "Do",
        text: "Site works, cabinetry, finishing and styling — with weekly updates until hand-over.",
    },
];

export const PORTFOLIO = [
    {
        id: "danau-kota-residence",
        title: "Danau Kota Residence",
        category: "Full Home Renovation",
        location: "Setapak, KL",
        year: "2024",
        cover:
            "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
        span: "md:col-span-8 md:row-span-2",
    },
    {
        id: "mont-kiara-kitchen",
        title: "Mont Kiara Kitchen",
        category: "Kitchen & Cabinetry",
        location: "Mont Kiara, KL",
        year: "2024",
        cover:
            "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldHJ5fGVufDB8fHx8MTc4MzQzNjg0OHww&ixlib=rb-4.1.0&q=85",
        span: "md:col-span-4",
    },
    {
        id: "shah-alam-terrace",
        title: "Shah Alam Terrace",
        category: "Refurbishing & Decor",
        location: "Shah Alam, Selangor",
        year: "2024",
        cover:
            "https://images.pexels.com/photos/8082243/pexels-photo-8082243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600",
        span: "md:col-span-4",
    },
    {
        id: "bangsar-townhouse",
        title: "Bangsar Townhouse",
        category: "Interior Design",
        location: "Bangsar, KL",
        year: "2023",
        cover:
            "https://images.unsplash.com/photo-1615529182904-14819c35db37?auto=format&fit=crop&w=1600&q=80",
        span: "md:col-span-6",
    },
    {
        id: "petaling-jaya-loft",
        title: "Petaling Jaya Loft",
        category: "Construction & Interior",
        location: "PJ, Selangor",
        year: "2023",
        cover:
            "https://images.unsplash.com/photo-1622372738946-62e02505feb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldHJ5fGVufDB8fHx8MTc4MzQzNjg0OHww&ixlib=rb-4.1.0&q=85",
        span: "md:col-span-6",
    },
    {
        id: "cheras-family-home",
        title: "Cheras Family Home",
        category: "Full Home Renovation",
        location: "Cheras, KL",
        year: "2023",
        cover:
            "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1600&q=80",
        span: "md:col-span-4",
    },
    {
        id: "subang-jaya-apartment",
        title: "Subang Jaya Apartment",
        category: "Interior Design",
        location: "Subang Jaya, Selangor",
        year: "2023",
        cover:
            "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
        span: "md:col-span-4",
    },
    {
        id: "puchong-duplex",
        title: "Puchong Duplex",
        category: "Ceilings & Flooring",
        location: "Puchong, Selangor",
        year: "2022",
        cover:
            "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
        span: "md:col-span-4",
    },
];

export const BEFORE_AFTER = [
    {
        id: "ba-1",
        title: "Danau Kota Living Room",
        before:
            "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1400&q=80",
        after:
            "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    },
    {
        id: "ba-2",
        title: "Mont Kiara Kitchen",
        before:
            "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80",
        after:
            "https://images.unsplash.com/photo-1639405069836-f82aa6dcb900?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBraXRjaGVuJTIwY2FiaW5ldHJ5fGVufDB8fHx8MTc4MzQzNjg0OHww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "ba-3",
        title: "Shah Alam Master Bedroom",
        before:
            "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
        after:
            "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "The team handled our full renovation end-to-end. What impressed us most was how disciplined the site was — no chaos, no surprises, just quiet, careful work.",
        name: "Faridah A.",
        location: "Mont Kiara, KL",
    },
    {
        quote:
            "We asked for a kitchen that could survive three kids and a decade. What we got was that — and a room we don't want to leave.",
        name: "Chan & Mei",
        location: "Petaling Jaya",
    },
    {
        quote:
            "HEYHOMECAN understood our brief on the first call. Every design revision made the home feel more like ours, not less.",
        name: "Nurul H.",
        location: "Setapak, KL",
    },
];

export const STATS = [
    { value: "120+", label: "Homes Transformed" },
    { value: "8+", label: "Years of Craft" },
    { value: "48hr", label: "Reply Guarantee" },
    { value: "100%", label: "In-house Team" },
];
